export default "__VITE_ASSET__CJpeXnlg__"